import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetch from 'cross-fetch';
import { mergeAbortSignals, TimedAbortSignal } from './abort-signal-utils.js';
var DEFAULT_FETCH_TIMEOUT = 60 * 1000 * 3;
export function fetchJson(_x) {
  return _fetchJson.apply(this, arguments);
}
function _fetchJson() {
  _fetchJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
    var opts,
      timeoutLength,
      timedAbortSignal,
      res,
      text,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          if (opts.body) {
            Object.assign(opts, {
              body: JSON.stringify(opts.body),
              headers: {
                'Content-Type': 'application/json'
              }
            });
          }
          timeoutLength = opts.timeout || DEFAULT_FETCH_TIMEOUT;
          timedAbortSignal = new TimedAbortSignal(timeoutLength);
          opts.signal = opts.signal ? mergeAbortSignals([opts.signal, timedAbortSignal.signal]) : timedAbortSignal.signal;
          _context.next = 7;
          return fetch(url, opts).finally(function () {
            return timedAbortSignal.clear();
          });
        case 7:
          res = _context.sent;
          if (res.ok) {
            _context.next = 13;
            break;
          }
          _context.next = 11;
          return res.text();
        case 11:
          text = _context.sent;
          throw new Error("HTTP request to '".concat(url, "' failed with status '").concat(res.statusText, "': ").concat(text));
        case 13:
          return _context.abrupt("return", res.json());
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchJson.apply(this, arguments);
}